import { Component, EventEmitter, Input, OnInit, Output, SimpleChange } from '@angular/core';
import { IAvailableTypes } from 'src/app/core/models/available-types.interface';
import { PageParams } from 'src/app/core/models/page-params.model';
import { UploadFileService } from 'src/app/core/services/upload-file.service';
import { IDocumentItem } from 'src/app/modules/customers-order-management/models/document.interface';
import { ISaleOrder } from '../../../models/sale-order.interface';
import { SaleOrderService } from '../../../services/sale-order.service';

@Component({
  selector: 'eci-sale-order-documents-list',
  templateUrl: './sale-order-documents-list.component.html',
  styleUrls: ['./sale-order-documents-list.component.scss']
})
export class SaleOrderDocumentsListComponent implements OnInit {

  pageParams: PageParams = new PageParams();

  @Input() info: ISaleOrder;
  @Input() isCreateMode: boolean = true;
  @Input() availableTypes: IAvailableTypes;
  @Input() availableFields: string[];

  @Output() infoChange = new EventEmitter<ISaleOrder>();

  documentList: IDocumentItem[]
  dataSource;

  pageChanged(e: PageParams): void {
    this.pageParams.pageIndex = e.pageIndex;
    this.pageParams.pageSize = e.pageSize;
    // this.getList(e.pageIndex + 1, e.pageSize);
  }

  constructor(
    public uploadFileSvc: UploadFileService,
    private orderSvc: SaleOrderService
  ) { }

  ngOnInit(): void {
    // this.documentList = this.info && this.info.orderDocuments || [];
    // this.dataSource = this.documentList;
    this.orderSvc.fileLoadedObserver.subscribe(_ => {
      this.getList();
    });

    this.orderSvc.fileLoadedObserver.subscribe(data => {
      this.orderSvc.getOrderById(this.info.id).subscribe(data => {
        this.infoChange.emit(data);
        this.dataSource = [...this.documentList];
      });
    });
  }

  displayedColumns: string[] = [
    'dateUploaded',
    'documentType', // TODO MAYBE NEED TO CHANGE TO ENUM
    'documnetStatus',
    'uploads',
    'linkToViewUpload',
    'delete'
  ];

  ngOnChanges(change: SimpleChange): void {
    if (change['info']) {
      this.documentList = this.info && this.info.orderDocuments || [];
      this.dataSource = this.documentList;
      const invoices = this.info?.invoices || [];
      const vatInvoice = invoices.filter(obj => obj.type == 5 );
      // invoice only visible from frontend side not coming from the database
      if(vatInvoice.length > 0 && !this.info.isB2B) {
        this.dataSource.unshift(vatInvoice[0]); 
      }
    }
  }

  downloadDoc(id): void {
    this.orderSvc.downloadFile(this.info.id, id);
  }

  uploadDoc(el: { id: number, e: any, file: any }): void {
    const files = el.e.dataTransfer ? el.e.dataTransfer.files : el.e.target.files;

    this.orderSvc.uploadFile(files, this.info.id, el.id);
  }

  deleteDoc(id): void {
    this.orderSvc.deleteOrderDoc(this.info.id, id).subscribe(data => {
      this.getList();
      this.orderSvc.getOrderById(this.info.id).subscribe(data => {
        this.infoChange.emit(data);
        this.dataSource = [...this.documentList];
      });
    })
  }

  public fileUpload(id, e: any, fileId) {
    if (!e.target.files) {
      return;
    }
    const files = e.dataTransfer ? e.dataTransfer.files : e.target.files;
    this.uploadFileSvc.uploadFile(files, "uploads", fileId)
    this.orderSvc.fileLoadedObserver.subscribe(data => {
      if (!data) return;
      const photo = JSON.parse(data);
      this.documentList.find(el => el.id == id).file = photo;
      this.info = this.model;
      this.infoChange.emit(this.info);
      this.updateDocs(id, this.documentList.find(el => el.id == id))
      this.dataSource = [...this.documentList];
    });
  }

  get model(): ISaleOrder {
    return {
      ...this.info,
      orderDocuments: this.documentList
    }
  }

  updateDocs(id, body): void {
    this.orderSvc.updateOrderDoc(this.info.id, id, body).subscribe(data => {
      this.orderSvc.getOrderById(this.info.id).subscribe(data => {
        this.infoChange.emit(data);
        this.dataSource = [...this.documentList];
      });
    })
  }

  getList(id: number = this.info.id): void {
    this.orderSvc.getOrderDocs(id).subscribe(data => {
      this.dataSource = data;
    })
  }
}
